export enum ROLE {
  RECRUITER = 'Recruiter',
  PAYMENT = 'Payment',
  COACH = 'Coach'
}
